import _regeneratorRuntime from "D:/workspace/smt-cloud/smt-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/workspace/smt-cloud/smt-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/workspace/smt-cloud/smt-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import { userMessageUnreadCount, userMessageList, readedUserMessage } from '@/api/auth/userMessage';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger
  },
  data: function data() {
    return {
      unreadCount: 0,
      query: {
        page: 0,
        size: 10
      },
      page: {
        content: []
      },
      list: [],
      messageDetailDialogVisible: false,
      message: {},
      messageListDialogVisible: false,
      appName: process.env.VUE_APP_NAME,
      marketCode: process.env.VUE_APP_MARKET_CODE
    };
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'user'])),
  created: function created() {
    this.fetchUserMessageUnreadCount();
    this.fetchUserMessageList();
  },
  methods: {
    fetchUserMessageUnreadCount: function fetchUserMessageUnreadCount() {
      var _this = this;

      userMessageUnreadCount().then(function (resp) {
        _this.unreadCount = resp.data;
      });
    },
    fetchUserMessageList: function fetchUserMessageList() {
      var _this2 = this;

      var query = this.query;
      query.tmp = new Date().getTime();
      userMessageList(query).then(function (resp) {
        _this2.page = resp;
        var content = resp.content;

        if (content && content.length) {
          var message = content.find(function (item) {
            return !item.isRead && item.forceRead;
          });

          if (message) {
            _this2.showMessageDetail(message);
          }
        }

        if (query.page === 0) {
          _this2.list = resp.content;
        }
      });
    },
    showMessageDetail: function showMessageDetail(message) {
      var _this3 = this;

      this.message = message;
      this.messageDetailDialogVisible = true;
      readedUserMessage([message.id]).then(function (resp) {
        _this3.fetchUserMessageUnreadCount();

        _this3.fetchUserMessageList();
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val - 1;
      this.fetchData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.size = val;
      this.fetchData();
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.$store.dispatch('user/logout');

              case 2:
                _this4.$router.push("/login?redirect=/"); // window.location.href = process.env.VUE_APP_BASE_API + '/logout'


              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isVip: function isVip() {
      var user = this.user;

      if (user.vip) {
        var now = new Date().getTime();
        var vipExpireTime = new Date(user.vipExpireTime).getTime();
        return now < vipExpireTime;
      }

      return false;
    }
  }
};